
import Vue from "vue";
import { IInvoiceData, IAppProperties } from "../types";
import InvoiceTable from "@/components/InvoiceTable.vue";
import InvoiceDefault from "../data/invoiceDefault";
import fieldEntryMixin from "@/components/mixins/fieldEntryMixin.vue";
import { clone } from "../util/clone";
import store from "../store";
import { mapGetters } from "vuex";
import { VMoney } from "v-money";
import AppPropsMixin from "@/components/mixins/AppPropsMixin.vue";
import PaymentPlanSignup from "@/components/PaymentPlanSignup.vue";

export default Vue.extend({
  name: "invoice-details",
  mixins: [fieldEntryMixin, AppPropsMixin],
  components: { InvoiceTable, PaymentPlanSignup },
  data: function() {
    return {
      amountDueAndPayingMatch: false as boolean,
      amountPayingIsMoreThanDue: false as boolean,
      moneyConfig: {
        decimal: ".",
        thousands: ",",
        prefix: "$ ",
        suffix: "",
        precision: 2,
        masked: true
      }
    };
  },
  props: {
    invoices: { type: Array as () => IInvoiceData[] }
  },
  watch: {
    invoices(newValue: IInvoiceData[]) {
      if (newValue.length > 0) {
        this.invoicePayment.docNumber = newValue[0].documentNumber;
        this.invoicePayment.refNumber = newValue[0].referenceNumber;
        this.invoicePayment.dunningBlock = newValue[0].dunningBlock;
      }
    },
    amountDue(newValue: string) {
      this.amountLocal = newValue;
    }
  },
  computed: {
    amountLocal: {
      get(): string {
        let amount: number = 0;

        if (this.invoices.length > 0) {
          amount = this.calculateAmountDue();
        }

        return amount.toFixed(2);
      },
      set(newValue: string) {
        let newValueMod: string = newValue.replace("$ ", "").replace(/,/g, "");
        let num: number = Number.parseFloat(newValueMod);

        this.updateAmountPaying(num);
      }
    },
    invoicePayment(): any {
      //@ts-ignore
      return store.getters.invoiceModule.getInvoicePayment;
    },
    appProps: {
      get(): IAppProperties {
        //@ts-ignore
        return store.getters.appModule.getAppProperties;
      },
      set(newValue: IAppProperties) {
        //@ts-ignore
        store.commit.appModule.SET_APP_PROPERTIES(newValue);
      }
    },
    amountDue(): string {
      //@ts-ignore
      return this.formatPrice(this.calculateAmountDue());
    }
  },
  methods: {
    updateAmountPaying(amountPaying: number) {
      let due: number = this.calculateAmountDue();

      this.amountDueAndPayingMatch = due > amountPaying;
      this.amountPayingIsMoreThanDue = due < amountPaying;
      this.invoicePayment.amountPaying = amountPaying;
    },
    // consider having this call the new controller code that calculates amount due
    calculateAmountDue(): number {
      let grossBill: number = 0;
      let amountPayed: number = 0;
      let idx: number = 0;

      this.invoices.forEach(i => {
        if (idx === 0) {
          grossBill = i.amountDue;
        } else {
          if (i.documentNumber.substring(0, 2) === "18") {
            // this is a multi-line invoice
            grossBill = grossBill + i.amountDue;
          } else {
            // this is a payment or credit
            amountPayed = amountPayed + i.amountDue;
          }
        }
        idx++;
      });

      let t: number = grossBill - amountPayed;
      let netBill: number = Number.parseFloat(t.toFixed(2));

      this.invoicePayment.amountDue = netBill;
      return netBill;
    },
    saveToStore() {
      //@ts-ignore
      store.commit.invoiceModule.SET_INVOICE_PAYMENT(this.invoicePayment);
    }
  }
});
